export default __webpack_public_path__ + "static/media/document.7bcee2e9.svg";